module.exports = __webpack_public_path__ + "static/media/lobster.f4929cde.png";